// This file defines the main navigation configuration
// The config is used in the common ui angular library as input for rendering the TaaS standard main navigation on the left side

import { TaasMenuItem } from 'utimaco-common-ui-angular';
//import chartIcon from '@material-icons/svg/svg/insert_chart/baseline.svg';
// see https://netbasal.com/simplifying-file-imports-in-angular-with-new-loader-options-4e94a0eb18af for importing svgs in angular ^17.1

// Menu icons come from the common UI icon library via `iconName` (same names as <lib-taas-icon>, e.g. in Access Management).
// Home keeps a codebase SVG via `iconSvg` because the library has no home/house icon yet.
import homeIcon from '../assets/icons/house.svg';

/********************************************************************************/
/**********************           WARNING         *******************************/
/********************************************************************************/
/* In order for the automatic role based filtering of menu entries to work      */
/* the link value must be spelled the same way as in the router configuration,  */
/* including trailing or leading slashes etc.                                   */
/********************************************************************************/
export const TAAS_MENU_ITEM_LIST_TS: TaasMenuItem[] = [
  {
    id: -1,
    type: 'link',
    active: true,
    name: $localize`:main-menu home link:Home`,
    link: 'home',
    iconSvg: homeIcon,
    children: [],
  },
  {
    id: 0,
    type: 'link',
    active: true,
    name: $localize`:main-menu home link:Dashboard`,
    link: 'dashboard',
    iconName: 'dashboard',
    children: [],
  },
  {
    id: 100,
    type: 'section',
    active: true,
    name: $localize`Cloud Clients`,
    link: 'cloud-clients',
    iconName: 'cloudClients',
    children: [
      {
        id: 101,
        type: 'link',
        active: true,
        name: $localize`Azure BYOK`,
        link: 'cloud-clients/azure-byok',
        iconName: 'azure',
        children: [],
      },
      {
        id: 102,
        type: 'link',
        active: true,
        name: $localize`Microsoft DKE`,
        link: 'cloud-clients/microsoft-dke',
        iconName: 'msdke',
        children: [],
      },
      {
        id: 103,
        type: 'link',
        active: true,
        name: $localize`Azure HYOK`,
        link: 'cloud-clients/azure-hyok',
        iconName: 'azure',
        children: [],
      },
      {
        id: 104,
        type: 'link',
        active: true,
        name: $localize`Google HYOK`,
        link: 'cloud-clients/google-hyok',
        iconName: 'google',
        children: [],
      },
    ],
  },
  {
    id: 2,
    type: 'section',
    active: false,
    name: $localize`Enterprise Clients`,
    link: 'enterprise-clients',
    iconName: 'server',
    children: [
      {
        id: 10,
        type: 'link',
        active: false,
        name: $localize`KMIP`,
        link: 'enterprise-clients/kmip',
        iconName: 'kmip',
        children: [],
      },
      {
        id: 11,
        type: 'link',
        active: false,
        name: $localize`TDE`,
        link: 'enterprise-clients/tde',
        iconName: 'tde',
        children: [],
      },
      {
        id: 12,
        type: 'link',
        active: false,
        name: $localize`REST`,
        link: 'enterprise-clients/rest',
        iconName: 'api',
        children: [],
      },
    ],
  },
  {
    id: 3,
    type: 'section',
    active: false,
    name: $localize`Access Management`,
    link: 'access-management',
    iconName: 'group',
    children: [
      {
        id: 13,
        type: 'link',
        active: false,
        name: $localize`Users`,
        link: 'access-management/users',
        iconName: 'userAdd',
        children: [],
      },
      {
        id: 14,
        type: 'link',
        active: false,
        name: $localize`Groups`,
        link: 'access-management/groups',
        iconName: 'groupAdd',
        children: [],
      },
    ],
  },
  {
    id: 4,
    type: 'section',
    active: false,
    name: $localize`HSM`,
    link: 'hsm',
    iconName: 'vault',
    children: [
      {
        id: 15,
        type: 'link',
        active: false,
        name: $localize`Connect HSM`,
        link: 'hsm/connect-hsm',
        iconName: 'hsmConn',
        children: [],
      },
      {
        id: 16,
        type: 'link',
        active: false,
        name: $localize`Modify HSM`,
        link: 'hsm/modify-hsm',
        iconName: 'hsmConf',
        children: [],
      },
    ],
  },
  {
    // Note: this HSM menu entry is only shown if the organization cannot manage their own HSM RoT -> filtering is done via the app route data properties
    id: 17,
    type: 'link',
    active: false,
    name: $localize`HSM`,
    link: 'hsm-list',
    iconName: 'vault',
    children: [],
  },
  {
    id: 5,
    type: 'link',
    active: false,
    name: $localize`Audit Log`,
    link: 'audit-logs',
    iconName: 'log',
    children: [],
  },
  {
    id: 6,
    type: 'link',
    active: false,
    name: $localize`Setting`,
    link: 'settings',
    iconName: 'settings',
    children: [],
  },
];
